/* eslint-disable prettier/prettier */
/* eslint-disable */

import { useState } from "react";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import MKBox from "components/MKBox";
import { IconButton } from "@mui/material";
import { TouchApp } from "@mui/icons-material"; // Importer et trykk ikon

function RotatingCard({ children }) {
  const [rotate, setRotate] = useState(false);

  // Denne funksjonen toggler rotasjonen
  const toggleRotate = () => setRotate((prev) => !prev); // Toggle rotasjon

  // Denne funksjonen stopper hendelsen på ikonet fra å propagere videre til kortet
  const handleIconClick = (event) => {
    event.stopPropagation(); // Hindrer at klikk på ikonet trigge kortets onClick
    toggleRotate();
  };

  return (
    <MKBox 
      sx={{ 
        perspective: "50rem",
        animation: rotate ? "none" : "pulse 1.5s infinite alternate ease-in-out",
        "@keyframes pulse": {
          "0%": { transform: "scale(1)" },
          "100%": { transform: "scale(1.05)" }
        }
      }}
    >
      <Card
        sx={{
          backgroundColor: "transparent",
          boxShadow: "none",
          position: "relative",
          transform: rotate ? "rotateY(180deg)" : "rotateY(0)", // Rotasjon basert på tilstanden
          transformStyle: "preserve-3d",
          transition: "all 0.8s cubic-bezier(0.34, 1.45, 0.7, 1)", // Glatt overgang
        }}
        onClick={toggleRotate} // Klikk for å snu kortet
      >
        {children}
        {/* Dette ikonet vil også trigge samme rotasjon, men stoppe propagasjonen */}
        <IconButton
          sx={{
            position: "absolute",
            bottom: "10px", // Plassér ikonet nederst på kortet
            left: "50%",
            transform: "translateX(-50%)", // Sentrere horisontalt
            zIndex: 10,
            color: "white", // Farge på ikonet
          }}
          aria-label="trykk meg"
          onClick={handleIconClick} // Håndterer klikk for å snu kortet (samme som kortet)
        >
          <TouchApp />
        </IconButton>
      </Card>
    </MKBox>
  );
}

RotatingCard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default RotatingCard;
